import i18n from "../../i18n";
import { DetectionSource } from "../apiEnums.generated";

// Note: keyed by both spellings on purpose. The same DTO reaches the Stoppages page two ways - fetched
// from the controller as a number, and pushed over the hub as the member name - and a live update that
// only knew about numbers blanked the column until the next refetch.
const labelKeyByValue: Record<string, "manual" | "gps" | "vendor"> = {
  [DetectionSource.Manual]: "manual",
  [DetectionSource.GpsDerived]: "gps",
  [DetectionSource.VendorCode]: "vendor",
  Manual: "manual",
  GpsDerived: "gps",
  VendorCode: "vendor"
};

export function detectionSourceLabel(source: DetectionSource | string | undefined): string {
  const key = labelKeyByValue[String(source ?? DetectionSource.Manual)];
  return key ? i18n.t(`detectionSource.${key}`) : "";
}

// Note: same both-spellings problem as the label above - a number over the controllers, a member name
// over the hub - so this cannot be a simple !== 0 check at the call sites.
const autoDetectedValues = new Set<string>([
  String(DetectionSource.GpsDerived),
  String(DetectionSource.VendorCode),
  "GpsDerived",
  "VendorCode"
]);

// Note: whether a machine put this row here rather than a person. Drives whether the verification mark
// is shown at all: a hand-entered row was never unchecked, so a tick claiming otherwise would be a lie.
export function isAutoDetected(source: DetectionSource | string | undefined): boolean {
  return autoDetectedValues.has(String(source ?? DetectionSource.Manual));
}
